export const lightClassColors = [
  '#CB4B51', '#FF8B48', '#FFCF71', '#F7A9E1', '#ECA3A1',
  '#E283B2', '#9A9CE3', '#8EBEF6', '#65C5FA', '#7ED691', '#53B38F'
];

const darkClassColors = [
  '#D42B33', '#F6772E', '#FFC24C', '#FF84DC', '#FF837F',
  '#E772AC', '#7F82E5', '#63AAFD', '#38B6FC', '#60DF7C', '#19BD7F'
];

export function getColor(lightColor, isDark) {
  if (!isDark) return lightColor;
  const idx = lightClassColors.indexOf(lightColor);
  return idx !== -1 ? darkClassColors[idx] : lightColor;
}

export const lightTheme = {
  // Primary (Key Color)
  primary: '#FF8B48',
  primaryHover: '#FF6C16',
  primaryAlpha5: 'rgba(255, 139, 72, 0.05)',
  primaryAlpha10: 'rgba(255, 139, 72, 0.1)',
  primaryAlpha20: 'rgba(255, 139, 72, 0.2)',
  primaryAlpha50: 'rgba(255, 139, 72, 0.5)',
  primaryGradient: 'linear-gradient(90deg, #FF8B48 0%, #FFA570 100%)',

  // Sub Key Color
  subKey: '#6DD49E',
  subKeyHover: '#2EAA69',
  subKeyAlpha50: 'rgba(109, 212, 158, 0.5)',

  // Point Colors
  pointYellow: '#FFB800',
  pointYellowHover: '#EEAB00',
  pointBlue: '#2F80ED',
  pointBlueHover: '#016BFB',
  pointRed: '#D92828',
  pointRedHover: '#FF0000',
  pointRedAlpha10: 'rgba(217, 40, 40, 0.1)',
  pointRedAlpha20: 'rgba(217, 40, 40, 0.2)',
  pointRedAlpha30: 'rgba(217, 40, 40, 0.3)',
  pointRedAlpha50: 'rgba(217, 40, 40, 0.5)',
  pointYellowAlpha30: 'rgba(255, 184, 0, 0.3)',

  // Gray
  gray: '#CBCBCB',

  // White
  white: '#FFFFFF',
  whiteAlpha20: 'rgba(255, 255, 255, 0.2)',

  // Black
  blackAlpha10: 'rgba(0, 0, 0, 0.1)',
  blackAlpha30: 'rgba(0, 0, 0, 0.3)',

  // Text
  keyText: '#232323',
  text: '#232323',
  subText: '#777777',
  historyText: '#777777',

  // Button
  buttonFill: '#F5F6F8',
  buttonStroke: '#DFDFDF',
  buttonFill2: '#969696',
  buttonFill3: '#E2E2E2',

  // Line
  line: '#D4D4D4',

  // Scroll Bar
  scrollBar: '#CFCFCF',

  // Gym Naem (Multi login)
  gymName: '#FFFFFF',

  // Shadow
  shadow: '0px 4px 16px rgba(0, 0, 0, 0.06)',
  shadowLarge: '0px 8px 40px rgba(0, 0, 0, 0.10)',

  // Background
  background: '#FDFCFB',
  subBackground: '#FFFFFF',
  thirdBackground: '#FBFBFB',
  thirdBackgroundStroke: '#F3F3F3',

  // Ai Chatting
  chatBoxBackground: `#FFFFFF`,

  // Bottom 
  bottomText: '#969696',

  // Logo
  logo1: '#D6D4D2',
  logo2: '#F2F2F1',
  logo3: '#B5B0AE',

  // Class Colors
  class1: '#CB4B51',
  class2: '#FF8B48',
  class3: '#FFCF71',
  class4: '#F7A9E1',
  class5: '#ECA3A1',
  class6: '#E283B2',
  class7: '#9A9CE3',
  class8: '#8EBEF6',
  class9: '#65C5FA',
  class10: '#7ED691',
  class11: '#53B38F',

  // Category Colors
  category1: '#6DD49E',
  category2: '#FF8B48',
  category3: '#FFB800',
  category4: '#D92828',
  category5: '#65C5FA',

  // ===== NEW Design Tokens (NEW_Tokens_WEB) =====
  // Text (Semantic)
  textPrimary: '#0D1111',
  textSecondary: '#657168',
  textTertiary: '#8B9A95',
  textDisabled: '#BFC4C1',
  textBrand: '#00B87A',
  textDanger: '#CB4B51',
  textWarning: '#FFB800',
  textInvert: '#F0EFEA',
  textWhite: '#FFFFFF',

  // Icon (Semantic)
  iconPrimary: '#ECF1EF',
  iconSecondary: '#1B1B1B',
  iconTertiary: '#BAC6C1',
  iconDisabled: '#ABABAB',
  iconBrand: '#00B87A',
  iconDanger: '#CB4B51',
  iconPointY: '#FFB800',
  iconPointY50: '#FFB800',
  iconPoint3: '#FFB800',
  iconClass1: '#CB4B51',
  iconClass2: '#FF8B48',
  iconClass3: '#FFB800',
  iconClass4: '#FFDF85',
  iconClass5: '#F7A9E1',
  iconClass6: '#FBCEEF',
  iconClass7: '#9A9CE3',
  iconClass8: '#00B87A',
  iconClass9: '#65C5FA',
  iconClass10: '#0E425F',

  // Surface (Semantic)
  surfaceBackground: '#ECF1EF',
  surfacePrimary: '#F8F9F8',
  surfaceSecondary: '#ECF1EF',
  surfaceTertiary: '#DAE3DF',
  surfaceQuaternary: '#BAC6C1',
  surfaceBrand: '#00B87A',
  surfaceBrand2: '#5DE0AE',

  // Stroke (Semantic)
  strokePrimary: '#E6ECE9',
  strokeSecondary: '#DAE3DF',
  strokeTertiary: '#F8F9F8',
  strokeDisabled5: '#F0EFEA',
  strokeDisabled: '#DAE3DF',
  strokeDivider: '#E6ECE9',
  strokeBrand: '#00B87A',
  strokeDanger: '#CB4B51',

  // Fill (Semantic)
  fillBrandSolid: '#00B87A',
  fillBrandSubtle: '#CDF7E7',
  fillBrandDim: '#CDF7E7',
  fillDangerSolid: '#CB4B51',
  fillDangerSubtle: '#F2CACB',
  fillWarningSolid: '#FFB800',
  fillWarningSubtle: '#FFEDB8',
  fillNeutralSolid: '#ECF1EF',
  fillNeutralRaised: '#E6ECE9',
  fillShadow: '#ECF1EF',
  fillShadowSoft: '#F8F9F8',
  fillWhite: '#FFFFFF',
  fillAccent: '#00B87A',
  fillInvert: '#38423F',
  fillLine: '#BAC6C1',

  // (APP)brand Green Scale (primitive - shared light/dark)
  // TODO: 라이트 모드 디자인 토큰 확정되면 수정 예정
  brand50: '#E8FAF1',
  brand75: '#DBF9ED',
  brand100: '#CDF7E7',
  brand125: '#B7F2DC',
  brand150: '#A4EFD0',
  brand175: '#8FEAC1',
  brand200: '#9BEFCF',
  brand225: '#86E8BD',
  brand250: '#6FDFAB',
  brand275: '#56D69A',
  brand300: '#5DE0AE',
  brand325: '#4CD49A',
  brand350: '#3DC988',
  brand375: '#33C081',
  brand400: '#2ECC8A',
  brand425: '#23C07F',
  brand450: '#1AB575',
  brand475: '#0DC67E',
  brand500: '#00B87A',
  brand525: '#06B073',
  brand550: '#0BA76C',
  brand575: '#109F65',
  brand600: '#0D9A5F',
  brand625: '#0E9159',
  brand650: '#0F8B54',
  brand675: '#0F834F',
  brand700: '#0F7B4C',
  brand725: '#0E7146',
  brand750: '#0E6B43',
  brand775: '#0E653F',
  brand800: '#0E5F3C',
  brand825: '#0D5638',
  brand850: '#0C5034',
  brand875: '#0C4B32',
  brand900: '#0B4630',
  brand925: '#0A3E2A',
  brand950: '#093624',
  brand975: '#072C1E',
  brand1000: '#052318',
  brand500Alpha50: 'rgba(0, 184, 122, 0.5)',
  brand500Alpha20: 'rgba(0, 184, 122, 0.2)',
  brand500Alpha5: 'rgba(0, 184, 122, 0.05)',

  // (WEB)brand Orange Scale (primitive - shared light/dark)
  // 웹 키컬러(primary #FF8B48) 계열 — APP 초록 brand*와 구분
  webBrand50: '#FFF4EC',
  webBrand75: '#FFEBDC',
  webBrand100: '#FFE1CC',
  webBrand150: '#FFD5B9',
  webBrand200: '#FFC9A6',
  webBrand250: '#FFBC93',
  webBrand300: '#FFB07F',
  webBrand350: '#FFA671',
  webBrand400: '#FF9D63',
  webBrand450: '#FF9456',
  webBrand500: '#FF8B48',
  webBrand550: '#F47F3B',
  webBrand600: '#E8732F',
  webBrand650: '#D56A27',
  webBrand700: '#C25A1E',
  webBrand750: '#AD4F1E',
  webBrand800: '#964312',
  webBrand850: '#80370F',
  webBrand900: '#6B2E0B',
  webBrand950: '#3A1A06',

  // yellow scale (primitive - base #FFB800 = pointYellow)
  yellow50: '#FFF8E5',
  yellow100: '#FFEDB8',
  yellow200: '#FFDF85',
  yellow300: '#FFD152',
  yellow400: '#FFC529',
  yellow500: '#FFB800',
  yellow600: '#E0A100',
  yellow700: '#B88400',
  yellow800: '#8A6300',
  yellow900: '#5C4200',
  yellow950: '#332400',

  // blue scale (primitive - base #65C5FA)
  blue50: '#EDF8FE',
  blue100: '#CCEBFD',
  blue200: '#A5DBFC',
  blue300: '#8FD2FB',
  blue400: '#7ACBFA',
  blue500: '#65C5FA',
  blue600: '#3BA8E5',
  blue700: '#2585C2',
  blue800: '#19638F',
  blue900: '#0E425F',
  blue950: '#072433',

  // red scale (primitive - base #CB4B51)
  red50: '#FBEDED',
  red100: '#F2CACB',
  red200: '#DD7C80',
  red300: '#D46368',
  red400: '#CB4B51',
  red500: '#CB4B51',
  red500Alpha50: 'rgba(203, 75, 81, 0.5)',
  red600: '#AE393F',
  red700: '#8C2D31',
  red800: '#682124',
  red900: '#451617',
  red950: '#260C0D',

  // pink scale (primitive - base #F7A9E1)
  pink50: '#FEF4FB',
  pink100: '#FDE3F6',
  pink200: '#FBCEEF',
  pink300: '#F9BDE9',
  pink400: '#F8B3E5',
  pink500: '#F7A9E1',
  pink600: '#E078C5',
  pink700: '#BD52A2',
  pink800: '#8F3A79',
  pink900: '#5F2651',

  // purple scale (primitive - base #9A9CE3)
  purple50: '#F4F4FC',
  purple100: '#E2E2F7',
  purple200: '#CCCDF1',
  purple300: '#B8B9EB',
  purple400: '#A9ABE7',
  purple500: '#9A9CE3',
  purple600: '#6E70CC',
  purple700: '#5052A8',
  purple800: '#3B3C7E',
  purple900: '#272853',

  // 구간 매출 차트 연도별 라인 색상 (Figma 팔레트 순서, 연도 수만큼 순환)
  chartYearPalette: [
    '#e8732f', '#8a6300', '#ffdf85', '#8f3a79', '#fbceef',
    '#3b3c7e', '#65c5fa', '#072433', '#ffb800', '#d92828'
  ],
};

export const darkTheme = {
  // Primary (Key Color)
  primary: '#FF8333',
  primaryHover: '#FF6C16',
  primaryAlpha5: 'rgba(255, 131, 51, 0.05)',
  primaryAlpha10: 'rgba(255, 122, 30, 0.1)',
  primaryAlpha20: 'rgba(255, 122, 30, 0.2)',
  primaryAlpha50: 'rgba(255, 122, 30, 0.5)',
  primaryGradient: 'linear-gradient(90deg, #983E00 0%, #FF8333 100%)',

  // Sub Key Color
  subKey: '#6DD49E',
  subKeyHover: '#2EAA69',
  subKeyAlpha: 'rgba(109, 212, 158, 0.5)',
  subKeyAlpha50: 'rgba(109, 212, 158, 0.5)',

  // Point Colors
  pointYellow: '#FFB800',
  pointYellowHover: '#EEAB00',
  pointBlue: '#2F80ED',
  pointBlueHover: '#016BFB',
  pointRed: '#D92828',
  pointRedHover: '#FF0000',
  pointRedAlpha10: 'rgba(217, 40, 40, 0.1)',
  pointRedAlpha20: 'rgba(217, 40, 40, 0.2)',
  pointRedAlpha30: 'rgba(217, 40, 40, 0.3)',
  pointRedAlpha50: 'rgba(217, 40, 40, 0.5)',
  pointYellowAlpha30: 'rgba(255, 184, 0, 0.3)',

  // Gray
  gray: '#CBCBCB',

  // White
  white: '#F1F1F1',
  whiteAlpha20: 'rgba(241, 241, 241, 0.2)',

  // Black
  blackAlpha10: 'rgba(0, 0, 0, 0.1)',
  blackAlpha30: 'rgba(0, 0, 0, 0.3)',

  // Text
  keyText: '#FF8333',
  text: '#EFEFEF',
  subText: '#EFEFEF',
  historyText: '#FFFFFF',

  // Button
  buttonFill: '#1D1D1D',
  buttonStroke: '#1D1D1D',
  buttonFill2: '#FF8333',
  buttonFill3: '#282828',

  // Line
  line: '#636363',

  // Scroll Bar
  scrollBar: '#FF8333',

  // Gym Naem (Multi login)
  gymName: '#F1F1F1',
  
  // Shadow
  shadow: '0px 4px 16px rgba(0, 0, 0, 0.06)',
  shadowLarge: '0px 8px 40px rgba(0, 0, 0, 0.10)',

  // Background
  background: '#0F0F0F',
  subBackground: '#1B1B1B',
  thirdBackground: '#212121',
  thirdBackgroundStroke: '#212121',

  // Ai Chatting
  chatBoxBackground: `#1B1B1B`,

  // Bottom Info
  bottomText: '#969696',

  // Logo
  logo1: '#1F1E1E',
  logo2: '#373737',
  logo3: '#1C1C1C',

  // Class Colors
  class1: '#D42B33',
  class2: '#FF8333',
  class3: '#FFCF71',
  class4: '#FF84DC',
  class5: '#FF837F',
  class6: '#E772AC',
  class7: '#7F82E5',
  class8: '#63AAFD',
  class9: '#38B6FC',
  class10: '#60DF7C',
  class11: '#19BD7F',

  // Category Colors
  category1: '#52B07F',
  category2: '#FF8333',
  category3: '#FFB800',
  category4: '#D92828',
  category5: '#38B6FC',

  // ===== NEW Design Tokens (NEW_Tokens_WEB) =====
  // Text (Semantic)
  textPrimary: '#FFFFFF',
  textSecondary: '#FFFFFF',
  textTertiary: '#ABABAB',
  textDisabled: '#4B534F',
  textBrand: '#2ECC8A',
  textDanger: '#CB4B51',
  textWarning: '#FFB800',
  textInvert: '#0E0E0E',
  textWhite: '#FFFFFF',

  // Icon (Semantic)
  iconPrimary: '#1F1F1F',
  iconSecondary: '#8B9A95',
  iconTertiary: '#141414',
  iconDisabled: '#141414',
  iconBrand: '#00B87A',
  iconDanger: '#CB4B51',
  iconPointY: '#FFB800',
  iconPointY50: '#8A6300',
  iconPoint3: '#FFB800',
  iconClass1: '#682124',
  iconClass2: '#964312',
  iconClass3: '#8A6300',
  iconClass4: '#FFDF85',
  iconClass5: '#8F3A79',
  iconClass6: '#FBCEEF',
  iconClass7: '#3B3C7E',
  iconClass8: '#0E5F3C',
  iconClass9: '#65C5FA',
  iconClass10: '#072433',

  // Surface (Semantic)
  surfaceBackground: '#0E0E0E',
  surfacePrimary: '#171717',
  surfaceSecondary: '#1F1F1F',
  surfaceTertiary: '#2C2C2C',
  surfaceQuaternary: '#717171',
  surfaceBrand: '#00B87A',
  surfaceBrand2: '#0B4630',

  // Stroke (Semantic)
  strokePrimary: '#1F1F1F',
  strokeSecondary: '#111111',
  strokeTertiary: '#0E0E0E',
  strokeDisabled5: '#080808',
  strokeDisabled: '#111111',
  strokeDivider: '#0E0E0E',
  strokeBrand: '#00B87A',
  strokeDanger: '#CB4B51',

  // Fill (Semantic)
  fillBrandSolid: '#109F65',
  fillBrandSubtle: '#0B4630',
  fillBrandDim: 'rgba(11, 70, 48, 0.4)',
  fillDangerSolid: '#CB4B51',
  fillDangerSubtle: '#AE393F',
  fillWarningSolid: '#FFB800',
  fillWarningSubtle: '#E0A100',
  fillNeutralSolid: '#0E0E0E',
  fillNeutralRaised: '#0E0E0E',
  fillShadow: '#000000',
  fillShadowSoft: 'rgba(13, 17, 17, 0.1)',
  fillWhite: '#FFFFFF',
  fillAccent: '#FFFFFF',
  fillInvert: '#FFFFFF',
  fillLine: '#3D3D3D',

  // (APP)brand Green Scale (primitive - shared light/dark)
  // TODO: 라이트 모드 디자인 토큰 확정되면 수정 예정
  brand50: '#E8FAF1',
  brand75: '#DBF9ED',
  brand100: '#CDF7E7',
  brand125: '#B7F2DC',
  brand150: '#A4EFD0',
  brand175: '#8FEAC1',
  brand200: '#9BEFCF',
  brand225: '#86E8BD',
  brand250: '#6FDFAB',
  brand275: '#56D69A',
  brand300: '#5DE0AE',
  brand325: '#4CD49A',
  brand350: '#3DC988',
  brand375: '#33C081',
  brand400: '#2ECC8A',
  brand425: '#23C07F',
  brand450: '#1AB575',
  brand475: '#0DC67E',
  brand500: '#00B87A',
  brand525: '#06B073',
  brand550: '#0BA76C',
  brand575: '#109F65',
  brand600: '#0D9A5F',
  brand625: '#0E9159',
  brand650: '#0F8B54',
  brand675: '#0F834F',
  brand700: '#0F7B4C',
  brand725: '#0E7146',
  brand750: '#0E6B43',
  brand775: '#0E653F',
  brand800: '#0E5F3C',
  brand825: '#0D5638',
  brand850: '#0C5034',
  brand875: '#0C4B32',
  brand900: '#0B4630',
  brand925: '#0A3E2A',
  brand950: '#093624',
  brand975: '#072C1E',
  brand1000: '#052318',
  brand500Alpha50: 'rgba(0, 184, 122, 0.5)',
  brand500Alpha20: 'rgba(0, 184, 122, 0.2)',
  brand500Alpha5: 'rgba(0, 184, 122, 0.05)',

  // (WEB)brand Orange Scale (primitive - shared light/dark)
  // 웹 키컬러(primary #FF8B48) 계열 — APP 초록 brand*와 구분
  webBrand50: '#FFF4EC',
  webBrand75: '#FFEBDC',
  webBrand100: '#FFE1CC',
  webBrand150: '#FFD5B9',
  webBrand200: '#FFC9A6',
  webBrand250: '#FFBC93',
  webBrand300: '#FFB07F',
  webBrand350: '#FFA671',
  webBrand400: '#FF9D63',
  webBrand450: '#FF9456',
  webBrand500: '#FF8B48',
  webBrand550: '#F47F3B',
  webBrand600: '#E8732F',
  webBrand650: '#D56A27',
  webBrand700: '#C25A1E',
  webBrand750: '#AD4F1E',
  webBrand800: '#964312',
  webBrand850: '#80370F',
  webBrand900: '#6B2E0B',
  webBrand950: '#3A1A06',

  // yellow scale (primitive - base #FFB800 = pointYellow)
  yellow50: '#FFF8E5',
  yellow100: '#FFEDB8',
  yellow200: '#FFDF85',
  yellow300: '#FFD152',
  yellow400: '#FFC529',
  yellow500: '#FFB800',
  yellow600: '#E0A100',
  yellow700: '#B88400',
  yellow800: '#8A6300',
  yellow900: '#5C4200',
  yellow950: '#332400',

  // blue scale (primitive - base #65C5FA)
  blue50: '#EDF8FE',
  blue100: '#CCEBFD',
  blue200: '#A5DBFC',
  blue300: '#8FD2FB',
  blue400: '#7ACBFA',
  blue500: '#65C5FA',
  blue600: '#3BA8E5',
  blue700: '#2585C2',
  blue800: '#19638F',
  blue900: '#0E425F',
  blue950: '#072433',

  // red scale (primitive - base #CB4B51)
  red50: '#FBEDED',
  red100: '#F2CACB',
  red200: '#DD7C80',
  red300: '#D46368',
  red400: '#CB4B51',
  red500: '#CB4B51',
  red500Alpha50: 'rgba(203, 75, 81, 0.5)',
  red600: '#AE393F',
  red700: '#8C2D31',
  red800: '#682124',
  red900: '#451617',
  red950: '#260C0D',

  // pink scale (primitive - base #F7A9E1)
  pink50: '#FEF4FB',
  pink100: '#FDE3F6',
  pink200: '#FBCEEF',
  pink300: '#F9BDE9',
  pink400: '#F8B3E5',
  pink500: '#F7A9E1',
  pink600: '#E078C5',
  pink700: '#BD52A2',
  pink800: '#8F3A79',
  pink900: '#5F2651',

  // purple scale (primitive - base #9A9CE3)
  purple50: '#F4F4FC',
  purple100: '#E2E2F7',
  purple200: '#CCCDF1',
  purple300: '#B8B9EB',
  purple400: '#A9ABE7',
  purple500: '#9A9CE3',
  purple600: '#6E70CC',
  purple700: '#5052A8',
  purple800: '#3B3C7E',
  purple900: '#272853',

  // 구간 매출 차트 연도별 라인 색상 (Figma 팔레트 순서, 연도 수만큼 순환)
  chartYearPalette: [
    '#e8732f', '#8a6300', '#ffdf85', '#8f3a79', '#fbceef',
    '#3b3c7e', '#65c5fa', '#072433', '#ffb800', '#d92828'
  ],
};
